{
  "approvals": {
    "title": "Today",
    "charactersShort": "chars",
    "tooltips": {
      "openPreview": "Open preview",
      "openPlanning": "Open planning",
      "lastChanged": "Last changed",
      "scheduledAt": "Scheduled at"
    }
  },
  "plannings": {
    "label": {
      "plural": "Plannings",
      "singular": "Planning"
    },
    "toasts": {
      "create": {
        "success": "Planning created"
      },
      "openItem": "Open planning"
    }
  },
  "events": {
    "label": {
      "plural": "Events",
      "singular": "Event"
    },
    "columnLabels": {
      "startTime": "Start time",
      "status": "Status",
      "organiser": "Organiser",
      "section": "Section",
      "planningStatus": "Planning status",
      "action": "Action"
    },
    "tooltips": {
      "organiser": "Organiser"
    }
  },
  "assignments": {
    "title": "Assignments",
    "columnLabels": {
      "assignmentTime": "Assignment time",
      "type": "Type"
    },
    "tooltips": {
      "assignmentStartTime": "Assignment start time"
    },
    "actionMenu": {
      "openArticle": "Open article",
      "openPlanning": "Open planning"
    },
    "myAssignments": "My assignments"
  },
  "factboxes": {
    "title": "Factboxes",
    "columnLabels": {
      "description": "Description",
      "lastChanged": "Last changed",
      "origin": "Origin"
    },
    "origin": {
      "original": "Original",
      "inArticle": "From article"
    },
    "articleSearchNotice": {
      "short": "From article: {{words}}",
      "explanation": "From article doesn't support boolean expressions – searching for {{words}}"
    }
  },
  "search": {
    "title": "Search",
    "placeholders": {
      "search": "Search"
    },
    "labels": {
      "plannings": "Plannings",
      "events": "Events",
      "articles": "Articles"
    },
    "columnLabels": {
      "date": "Date"
    }
  },
  "login": {
    "loginWith": "Log in with",
    "rememberMe": "Remember me next time",
    "loggingIn": "Logging in..."
  },
  "timeless": {
    "title": "Timeless",
    "columnLabels": {
      "category": "Category",
      "lastChanged": "Last changed",
      "actions": "Actions"
    },
    "toolbar": {
      "allCategories": "All categories"
    },
    "actions": {
      "new": "New timeless",
      "openPlanning": "Open original planning",
      "convertToArticle": "Plan as article"
    },
    "placeholders": {
      "addCategory": "Add category"
    },
    "toasts": {
      "articlePlanned": "Article planned",
      "timelessSaved": "Timeless saved",
      "conversionFailed": "Could not create the new document: {{message}}",
      "notAuthenticated": "Unable to convert: not authenticated",
      "documentNotFound": "Document not found",
      "openArticle": "Open article",
      "openTimeless": "Open timeless",
      "openPlanning": "Open planning"
    }
  },
  "imageSearch": {
    "title": "Images",
    "labels": {
      "mediaType": "Media type",
      "distributor": "Distributor",
      "allDistributors": "All distributors",
      "image": "Image",
      "graphic": "Graphic",
      "close": "Close",
      "searchFailed": "Image search failed",
      "retry": "Try again",
      "noResults": "No results",
      "previous": "Previous image",
      "next": "Next image"
    }
  }
}
